export default __webpack_public_path__ + "static/media/arrowUpPapyrus.8622935d.svg";